@if (isActive) {
  <topo-modal [isActive]="isActive" [backgroundCanClose]="true" [isCard]="true" (close)="close()">
    <div class="modal-header">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">
          {{
          (configuredChannel?.uId === emptyGuid
          ? 'MANAGEMENT.COMMUNICATION-CENTER.CREATE-CHANNEL'
          : 'MANAGEMENT.COMMUNICATION-CENTER.UPDATE-CHANNEL'
          ) | translate
          }}
        </h5>
        <div class="dialog-close" (click)="close()"><i class="icon icon-close-X"></i></div>
      </div>
    </div>
    <div class="modal-body">
      <form>
        <div class="field">
          <div class="channel-type">{{ configuredChannel?.channelTypeDisplay }}</div>
          <div><img [src]="configuredChannel?.logoImagePath" /></div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.NAME' | translate }}</label>
          <div>
            <input
              class="input is-fullwidth"
              type="text"
              placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.NAME' | translate }}"
              [(ngModel)]="configuredChannel.name"
              name="name"
              />
          </div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.DESCRIPTION' | translate }}</label>
          <div>
            <textarea
              name="description"
              class="textarea"
              placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.DESCRIPTION' | translate }}"
              [(ngModel)]="configuredChannel.description"
            ></textarea>
          </div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.ORGANIZATION-ID' | translate }}</label>
          <div>
            <input
              class="input"
              type="text"
              placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.ORGANIZATION-ID' | translate }}"
              [(ngModel)]="configuredChannel.settings.organizationId"
              name="organizationId"
              />
          </div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.USERNAME' | translate }}</label>
          <div>
            <input
              class="input"
              name="username"
              type="text"
              placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.USERNAME' | translate }}"
              [(ngModel)]="configuredChannel.settings.username"
              name="username"
              />
          </div>
        </div>
        <div class="field">
          <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.PASSWORD' | translate }}</label>
          <div>
            <input
              class="input"
              type="password"
              placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.PASSWORD' | translate }}"
              [(ngModel)]="configuredChannel.settings.password"
              name="password"
              />
          </div>
        </div>
        <!-- Contacts Datasets Form -->
        <h5>{{ 'MANAGEMENT.COMMUNICATION-CENTER.CONTACT-DATASETS' | translate }}</h5>
        <div class="separator"></div>
        <ng-container [formGroup]="configuredContactDatasetsFormGroup">
          <div formArrayName="contactDatasets">
            <div fxLayout="row" fxLayoutAlign="left">
              <div class="mr-2" style="width: 45%" >
                <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.ASSET-DATASET' | translate }}</label>
              </div>
              <div class="mr-2" style="width: 45%" >
                <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.CONTACT-ID-FIELD' | translate }}</label>
              </div>
            </div>
            @for (contactDatasetForm of configuredContactDatasetsFormGroup?.get('contactDatasets').controls; track $index; let i = $index) {
              <div>
                <div [formGroup]="contactDatasetForm" fxLayout="row" fxLayoutAlign="start start">
                  <div class="field mr-2" style="width: 45%" fxLayout="column">
                    <div class="select is-fullwidth">
                      <select formControlName="contactsDatasetUId" (change)="datasetUpdated(contactDatasetForm)">
                        @for (dataset of datasets; track dataset.uId) {
                          <option [ngValue]="dataset.uId">{{ dataset.name }}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div class="field mr-2" style="width: 45%" fxLayout="column">
                    <div class="select is-fullwidth">
                      <select formControlName="contactIdFieldUId">
                        @for (field of getDatasetContactIdFields(contactDatasetForm); track field) {
                          <option [ngValue]="field.uId">{{ field.displayName }}</option>
                        }
                      </select>
                    </div>
                  </div>
                  <div style="width: 50px" fxLayoutAlign="space-around top" fxLayout="column">
                    <button
                      class="button is-small is-ghost mt-1"
                      (click)="deleteContactsDataset(i)"
                      [title]="'MANAGEMENT.COMMUNICATION-CENTER.REMOVE-DATASET' | translate">
                      <i class="icon icon-delete_trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
          <div fxLayout="row" fxLayoutAlign="space-around" class="my-4">
            <button class="button is-secondary" (click)="addContactsDataset()" style="border-radius: 6px">
              <i class="icon icon-add_plus_zoom-in"></i>
              <span>{{ 'MANAGEMENT.COMMUNICATION-CENTER.ADD-DATASET' | translate }}</span>
            </button>
          </div>
        </ng-container>
      </form>
    </div>
    <div class="modal-footer">
      <div fxLayout="row" fxLayoutAlign="end" class="mt-4 mb-4">
        <div style="margin-right: 5px">
          <button class="button is-secondary" (click)="cancelClick()">{{ 'MANAGEMENT.COMMUNICATION-CENTER.CANCEL' | translate }}</button>
        </div>
        <div>
          <button class="button is-primary" (click)="saveClick()">{{ 'MANAGEMENT.COMMUNICATION-CENTER.SAVE' | translate }}</button>
        </div>
      </div>
    </div>
  </topo-modal>
}
